import { useState, useCallback, useEffect } from 'react';
export const defaultTime = 1450;

/**
 * @typedef {Object} ExecutionResult
 * @property {boolean} isInProgress
 * @property {boolean} isFinished
 * @property {Function} start
 */

/**
 * @param {number} initialMinimumTime
 * @returns {ExecutionResult}
 */
export const useMinimalExecutionTime = (initialMinimumTime = defaultTime) => {
  const [inProgress, setInProgress] = useState(true);
  const [time, setTime] = useState(initialMinimumTime);
  const start = useCallback((newTime = defaultTime) => {
    setTime(newTime);
    setInProgress(true);
  }, []);
  useEffect(() => {
    if (!inProgress) {
      return;
    }
    const timeout = setTimeout(() => {
      setInProgress(false);
    }, time);

    // eslint-disable-next-line consistent-return
    return () => {
      clearTimeout(timeout);
    };
  }, [inProgress, time]);
  return {
    isInProgress: inProgress,
    isFinished: !inProgress,
    start
  };
};